// extracted by mini-css-extract-plugin
export var button = "_a5-7";
export var buttonRow = "_a5-6";
export var fadeIn = "_a5-1";
export var gradient = "_a5-0";
export var panel = "_a5-2";
export var panelIn = "_a5-3";
export var subtitle = "_a5-5";
export var title = "_a5-4";